<div #body class="message-body" [class.is-clamped]="!expanded()" [class.is-expandable]="overflowing() || expanded()"
    [attr.role]="overflowing() || expanded() ? 'button' : null"
    [attr.tabindex]="overflowing() || expanded() ? 0 : null"
    [attr.aria-expanded]="overflowing() || expanded() ? expanded() : null"
    (click)="toggle()" (keydown.enter)="toggle()" (keydown.space)="toggle()">{{ text() }}</div>

<button type="button" class="copy-btn" aria-label="Kopiér besked" ngbTooltip="Kopiér besked" placement="left"
    container="body" (click)="copy($event)">
    <i class="fa-solid fa-copy" aria-hidden="true"></i>
</button>
